export default __webpack_public_path__ + "static/media/smaller_soju.605ca49b.png";